import React, { useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import toast, { Toaster } from 'react-hot-toast'
import { FiChevronLeft, FiUploadCloud } from 'react-icons/fi'
import ActualiteService from '../../service/ActualiteService'
import '../styles/AdminForm.css'

const FormActualité = () => {
  const navigate = useNavigate()
  const fileInputRef = useRef(null)
  const authorization = localStorage.getItem('token')

  const [image, setImage] = useState(null)
  const [preview, setPreview] = useState(null)
  const [isVideo, setIsVideo] = useState(false)
  const [error, setError] = useState(null)
  const [submitting, setSubmitting] = useState(false)

  const handleFile = (fileList) => {
    const file = fileList?.[0]
    if (!file || !(file.type.startsWith('image/') || file.type.startsWith('video/'))) return
    if (preview) URL.revokeObjectURL(preview)
    setImage(file)
    setPreview(URL.createObjectURL(file))
    setIsVideo(file.type.startsWith('video/'))
    setError(null)
  }

  const handleDrop = (e) => {
    e.preventDefault()
    handleFile(e.dataTransfer.files)
  }

  const removeFile = () => {
    if (preview) URL.revokeObjectURL(preview)
    setImage(null)
    setPreview(null)
    setIsVideo(false)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!image) {
      setError('Ajoutez un fichier média')
      document.querySelector('.ata-error')?.scrollIntoView({ behavior: 'smooth', block: 'center' })
      return
    }

    const formData = new FormData()
    formData.append('image', image)

    setSubmitting(true)
    try {
      await ActualiteService.ajouter(formData, authorization)
      toast.success('Fichier ajouté avec succès')
      setTimeout(() => navigate('/admin/Actualite'), 800)
    } catch (err) {
      toast.error("Échec de l'ajout")
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className="ata-page">
      <Toaster />

      <div className="ata-header">
        <button type="button" className="ata-back" onClick={() => navigate('/admin/Actualite')}>
          <FiChevronLeft size={16} />
        </button>
        <div>
          <h1 className="ata-title">Ajouter une actualité</h1>
          <p className="ata-subtitle">Publiez une image ou une vidéo dans les actualités</p>
        </div>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="ata-card" style={{ maxWidth: 640 }}>
          <div className="ata-card__label">Vidéo ou fichier média</div>

          {!preview ? (
            <div
              className={`ata-dropzone ${error ? 'ata-dropzone--error' : ''}`}
              onDragOver={(e) => e.preventDefault()}
              onDrop={handleDrop}
              onClick={() => fileInputRef.current.click()}
            >
              <FiUploadCloud size={32} />
              <p className="ata-dropzone__text">Glisser-déposer ou <span>cliquer pour choisir</span></p>
              <p className="ata-dropzone__hint">Vidéo ou image</p>
              <input ref={fileInputRef} type="file" accept="video/*,image/*" hidden onChange={(e) => handleFile(e.target.files)} />
            </div>
          ) : (
            <div className="ata-preview-grid">
              <div className="ata-preview-item">
                {isVideo ? (
                  <video src={preview} controls />
                ) : (
                  <img src={preview} alt="Aperçu" />
                )}
                <button type="button" className="ata-preview-remove" onClick={removeFile}>✕</button>
              </div>
            </div>
          )}
          {error && <p className="ata-error">{error}</p>}
        </div>

        <div className="ata-footer-actions">
          <button type="button" className="ata-btn ata-btn--ghost" onClick={() => navigate('/admin/Actualite')}>Annuler</button>
          <button type="submit" className="ata-btn ata-btn--primary" disabled={submitting}>
            {submitting ? (<><span className="ata-spinner" /> Ajout…</>) : 'Ajouter'}
          </button>
        </div>
      </form>
    </div>
  )
}

export default FormActualité
